import { selectCurrentProgrammes, selectCompletedProgrammes, dateMs } from '../../functions/shared/programmeSelection';

const statusLabels = {
  started: 'Avviato', waiting: 'Da iniziare', hold: 'Sospeso', completed: 'Completato',
};
const formLabels = {
  not_started: 'Questionario iniziale non compilato',
  draft: 'Questionario salvato, non inviato',
  submitted: 'Questionario iniziale inviato',
  unknown: 'Questionario iniziale da verificare',
};
const displayLabels = {
  current: 'In corso', complete: 'Completato', 'not-started': 'Non compilato',
  draft: 'Non inviato', waiting: 'Da iniziare', hold: 'Sospeso', review: 'Da verificare',
};
const formatDate = value => {
  const stamp = dateMs(value);
  return stamp == null ? 'data non disponibile' : new Intl.DateTimeFormat('it-IT', {
    dateStyle: 'short', timeZone: 'Europe/Rome',
  }).format(new Date(stamp));
};

function displayState(record) {
  if (!record.validFraction) return 'review';
  if (record.state === 'completed') return 'complete';
  if (record.state === 'hold') return 'hold';
  if (record.state === 'waiting') {
    if (record.initialFormStatus === 'not_started') return 'not-started';
    if (record.initialFormStatus === 'draft') return 'draft';
    return 'waiting';
  }
  return 'current';
}

function progressEntry(record) {
  const completed = record.state === 'completed';
  const state = displayState(record);
  const position = record.validFraction
    ? `${completed ? 'Ultimo programma' : 'Programma corrente'}: ${record.index} di ${record.total}`
    : 'Posizione del programma da verificare';
  const status = statusLabels[record.state] || 'Da verificare';
  const summary = `${record.productLabel} · ${record.validFraction ? record.fraction : 'Posizione da verificare'} · ${status}`;
  const details = [
    record.productLabel,
    position,
    `Programmi conclusi o archiviati: ${record.completedProgrammes}${record.validFraction ? ` su ${record.total}` : ''}`,
    `Stato del percorso: ${status}`,
    formLabels[record.initialFormStatus] || formLabels.unknown,
  ];
  if (completed) details.push(`Check finale effettuato: ${formatDate(record.completedAt)}`);
  else if (record.previousCompletedGroup) details.push('Percorso precedente concluso');
  const expiry = record.expireAt || record.expiresAt;
  details.push(`Scadenza del programma: ${formatDate(expiry)}${record.expired ? ' · superata' : ''}`);
  if (record.orderRef) details.push(`Riferimento ordine: ${record.orderRef}`);
  return {
    key: `${record.uid}:${record.groupId}:${record.programmeId}`,
    programmeId: record.programmeId,
    groupId: record.groupId,
    label: record.fraction,
    state,
    statusLabel: displayLabels[state],
    summary,
    details,
    record,
  };
}

// Use the monitor's exact selection, including manual unlocks and verified final
// checks. Commercial expiration and purchase deadlines belong to other adapters.
export function resolveProgrammeProgress({ uid, percorsi = [], products = [], user = {}, now = new Date() } = {}) {
  const userId = String(uid || '').trim();
  const input = { percorsi, products, users: userId ? [{ ...user, id: userId }] : [], now };
  const selected = selectCurrentProgrammes(input);
  const completed = selectCompletedProgrammes({ ...input, ...selected });
  const entries = [...selected.records, ...completed].map(progressEntry);
  if (!entries.length) {
    const summary = 'Nessun percorso corrente o completato verificabile';
    entries.push({
      key: `${userId}:review`, programmeId: null, groupId: null,
      label: 'Da verificare', state: 'review', statusLabel: displayLabels.review, summary,
      details: [summary, 'Verifica percorsi, sequenza e check finale nel profilo.'],
      record: null,
    });
  }
  return {
    entries,
    summary: entries.length === 1 ? entries[0].summary : `${entries.length} percorsi correnti · ${entries.map(entry => entry.label).join(' · ')}`,
    anomalies: selected.anomalies,
  };
}
